export const TABLE_ATTACHMENT_ICON = 'table_large';

export const REPORT_ATTACHMENT_ICON = 'file_chart';

export const DEFAULT_ATTACHMENT_CONFIG = {
  value: 'full-report',
  format: 'pdf',
  icon: REPORT_ATTACHMENT_ICON
};
